export default __webpack_public_path__ + "static/media/view.ab5c4f2a.svg";